import React from 'react';
import { PropTypes } from 'prop-types';
import { ProjectIcon } from '~/modules/common/components/Icons';
import LabelledIcon from '../LabelledIcon';

const icon = <ProjectIcon size="xsmall" />;

const Project = ({
  classes,
  project: { displayText },
  disablePadding = false,
  dataQeId = 'Project'
}) => (
  <LabelledIcon
    classes={classes}
    icon={icon}
    label={displayText}
    dataQeId={dataQeId}
    disablePadding={disablePadding}
  />
);

Project.propTypes = {
  classes: PropTypes.object,
  project: PropTypes.shape({
    displayText: PropTypes.string
  }).isRequired,
  dataQeId: PropTypes.string,
  disablePadding: PropTypes.bool
};

export default Project;
